var _circle, _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    fill: "#101010",
    stroke: "url(#paint0_linear_5781_3289)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7246 15.6592C20.5238 16.2017 21.0838 16.9367 21.0838 17.9167V19.6667H23.4171V17.9167C23.4171 16.645 21.3346 15.8925 19.7246 15.6592Z",
    fill: "#3493FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2503 15C16.539 15 17.5837 13.9553 17.5837 12.6666C17.5837 11.378 16.539 10.3333 15.2503 10.3333C13.9617 10.3333 12.917 11.378 12.917 12.6666C12.917 13.9553 13.9617 15 15.2503 15Z",
    fill: "#3493FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7497 15C20.0388 15 21.083 13.9558 21.083 12.6666C21.083 11.3775 20.0388 10.3333 18.7497 10.3333C18.4755 10.3333 18.2188 10.3916 17.9738 10.4733C18.4758 11.0941 18.7497 11.8683 18.7497 12.6666C18.7497 13.465 18.4758 14.2392 17.9738 14.86C18.2188 14.9416 18.4755 15 18.7497 15ZM15.2497 15.5833C13.6922 15.5833 10.583 16.365 10.583 17.9166V19.6666H19.9163V17.9166C19.9163 16.365 16.8072 15.5833 15.2497 15.5833Z",
    fill: "#3493FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94114 16.5703V11.6555H10.0562V16.5703H8.94114ZM7.04128 14.6705V13.5554H11.9561V14.6705H7.04128Z",
    fill: "#3493FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5781_3289",
    x1: 0,
    y1: 0,
    x2: 24,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3493FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSign);
export default __webpack_public_path__ + "static/media/sign.929973814d855d215a85fe0de1b8258d.svg";
export { ForwardRef as ReactComponent };